import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
// import { LogoutModal } from 'components/modals';
import closeIcon from 'assets/close-arrow.svg';
import RipplrLogoWhite from 'assets/LogiTrack_Logo_Small.svg';
import { useUnAuthRoute } from 'hooks';
import { NavLinks } from 'components';
import { toggleSidebar } from 'store/appSlice';
import { Box, Flex, Image } from 'atoms';

export const Nav = styled.nav`
	position: fixed;
	top: 0;
	left: 0;
	z-index: 111;
	max-width: 240px;
	width: 100%;
	height: 100vh;
	background-color: ${(props) => props.theme.colors.primary};
	transition: 0.5s;
	overflow-y: auto;
	overflow-x: hidden;
`;

export const Upload = styled(Box)`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 120px;
	height: 40px;
	margin: 25px 0;
	border: 1px solid ${(props) => props.theme.colors.EagleGreen};
	background-color: ${(props) => props.theme.colors.MidnightGreen};
	font-size: 14px;
	font-weight: 300;
	color: ${(props) => props.theme.colors.white};
	line-height: 40px;
	text-align: center;
	cursor: pointer;
`;

export const Close = styled(Box)`
	position: fixed;
	bottom: 30px;
	display: none;
	transition: 0.5s;
`;

export default function SideBar() {
	const isUnAuth = useUnAuthRoute();
	const dispatch = useDispatch();
	const { sideBarStatus } = useSelector((state) => state.app);
	if (isUnAuth) {
		return null;
	}

	return (
		<Nav sideBarStatus={sideBarStatus}>
			<Flex background="#fff" justifyContent="center" width="100%">
				<Image width={160} height={80} src={RipplrLogoWhite} alt="home" />
			</Flex>
			<Flex
				position="relative"
				justifyContent="center"
				flexDirection="column"
				alignItems="center"
				height="90%"
			>
				<Box height="100%" width="100%">
					<NavLinks />
				</Box>
				<Close sideBarStatus={sideBarStatus} onClick={() => dispatch(toggleSidebar(false))}>
					<img src={closeIcon} style={{ marginRight: '2px' }} alt="close" /> Close
				</Close>
			</Flex>
			{/* <LogoutModal /> */}
		</Nav>
	);
}
